import styled from '@emotion/styled'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { theme } from 'styles/theme/hav-theme'
export const ValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
`

export const ValueWrapper = styled(ValueRow)`
  flex-wrap: wrap;
  justify-content: space-between;
`

export const TitleRow = styled(ValueRow)`
  gap: ${theme.spacing.xs};
`

export const ValueTexts = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`

export const Title = styled.span`
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.high};
  line-height: ${theme.typography.lineHeight.sm};
`

export const Value = styled.span`
  font-size: ${theme.typography.sizes.xs};
  color: ${theme.colors.neutral.medium};
  line-height: ${theme.typography.lineHeight.sm};
`

// TODO: Remove this InfoOutlinedIcon and use the Icon component
export const TooltipIcon = styled(InfoOutlinedIcon)`
  color: ${theme.colors.primary.main};
  font-size: ${theme.typography.sizes['2xs']};
`

export const IconContainer = styled.div<{
  background: string
}>(
  ({ background }) => `
  background-color: ${background};
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`,
)
